import { styled } from "goober";
import { Icon, type IconName, type Size } from "./Icon";

const Default = styled("span")`
  display: flex;
  transition:
    opacity 0.15s ease-out,
    transform 0.15s ease-out;
`;

const Check = styled("span")`
  position: absolute;
  display: flex;
  opacity: 0;
  transform: rotate(-90deg) scale(0.5);
  transition:
    opacity 0.15s ease-out,
    transform 0.15s ease-out;
`;

const Wrap = styled("span")`
  position: relative;
  display: inline-flex;
  &[data-copied] {
    ${Default} {
      opacity: 0;
      transform: rotate(90deg) scale(0.5);
    }
    ${Check} {
      opacity: 1;
      transform: rotate(0deg) scale(1);
    }
  }
`;

export function AnimatedCopyIcon({
  copied,
  size = 12,
  icon = "copy",
}: {
  copied: boolean;
  size?: Size;
  icon?: IconName;
}) {
  return (
    <Wrap data-copied={copied || undefined}>
      <Default>
        <Icon name={icon} size={size} />
      </Default>
      <Check>
        <Icon name="check" size={size} />
      </Check>
    </Wrap>
  );
}
